import { css, styled } from 'styled-components';

export const centeredStyle = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
`;
export const Title = styled.h1`
  text-align: center;
`;
export const ConsentContent = styled.div`
  text-align: center;
`;
export const ProgressbarContainer = styled.div`
  ${centeredStyle};
  background: rgba(0, 0, 0, 0.1);
`;
export const ConsentFormContainer = styled.div`
  padding: 12px;
`;
export const LocalIssuedImageListTable = styled.table`
  width: 100%;
  border: 1px solid;
  border-collapse: collapse;
  margin-top: 40px;

  th,
  td {
    border: 1px solid;
  }
`;
export const DateText = styled.p`
  text-align: center;
`;
export const ConsentButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
`;
export const ErrorMessage = styled.div`
  ${centeredStyle};
  padding: 24px;
  text-align: center;
`;
export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  box-sizing: border-box;
  padding-top: 50px;
  padding-right: 20px;
  padding-left: 20px;
`;
export const SuccessMessage = styled.div`
  text-align: center;
  word-break: keep-all;
`;
